import { SvgSymbol } from '../symbol-factory';

export const Spinner: SvgSymbol = (props) => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}
  >
    <path
      d="M20.6571 12C21.3988 12 22.0093 11.3961 21.91 10.6611C21.7069 9.15818 21.1638 7.71499 20.3147 6.4443C19.2159 4.79981 17.6541 3.51809 15.8268 2.76121C13.9996 2.00433 11.9889 1.8063 10.0491 2.19215C8.10929 2.578 6.32746 3.53041 4.92894 4.92894C3.53041 6.32746 2.578 8.10929 2.19215 10.0491C1.8063 11.9889 2.00433 13.9996 2.76121 15.8268C3.51809 17.6541 4.79981 19.2159 6.4443 20.3147C7.71499 21.1637 9.15818 21.7069 10.6611 21.91C11.3961 22.0093 12 21.3988 12 20.6571C12 19.9154 11.3938 19.3266 10.6646 19.1912C9.69391 19.0109 8.76507 18.6351 7.93649 18.0815C6.73369 17.2778 5.79622 16.1355 5.24263 14.799C4.68905 13.4625 4.5442 11.9919 4.82642 10.5731C5.10864 9.15429 5.80524 7.85104 6.82814 6.82814C7.85104 5.80524 9.15429 5.10864 10.5731 4.82642C11.9919 4.5442 13.4625 4.68905 14.799 5.24263C16.1355 5.79622 17.2778 6.73369 18.0815 7.93649C18.6351 8.76507 19.0109 9.69391 19.1912 10.6646C19.3266 11.3938 19.9154 12 20.6571 12Z"
      fill="url(#paint0_linear_10867_38718)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_10867_38718"
        x1="12"
        y1="2"
        x2="12"
        y2="22"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={props?.fill} />
        <stop offset="1" stopColor={props?.fill} stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
